module.exports = __webpack_public_path__ + "img/value-betrusted.f31fcf20.svg";